<template>
  <!-- 出行人列表 选择出行人 -->
  <div>
    <van-popup
      v-model="isShow"
      :close-on-click-overlay="false"
      :close-on-popstate="true"
      :get-container="getContainer"
      class="full-height full-width"
      position="right"
      safe-area-inset-bottom
    >
      <div class="emp">
        <ld-navbar
          @click-left="toggle"
          @click-right="addEmp"
        >
          <van-search
            v-if="showSearch"
            v-model.lazy="value"
            :placeholder="$t('nbs','姓名/工号/手机号')"
            maxlength="10"
            @clear="clear"
          />
          <span v-else>{{ $t('I001', '请选择出行人') }}</span>
          <template v-slot:right>
            <div
              v-if="showAddEmp"
              slot="right"
            >
              <van-icon
                name="plus"
                size="20"
              />
            </div>
          </template>
        </ld-navbar>

        <!--  -->
        <div v-show="showTab">
          <van-tabs
            v-model="index"
            line-height="2px"
            line-width="20px"
            swipeable
            @change="changeTab"
          >
            <van-tab
              v-if="showTabIndex.indexOf(0) > -1"
              :name="0"
              title="常旅客"
            >
              <emp-list
                :checked-list="travelerList"
                :index="index"
                :lists="clkList"
                :page="clkPage"
                @check="check"
                @dele="dele"
                @get-list="getList"
              />
            </van-tab>
            <van-tab
              v-if="showTabIndex.indexOf(1) > -1"
              :name="1"
              :title="$t('A111','同事')"
            >
              <emp-list
                :checked-list="travelerList"
                :index="index"
                :lists="empList"
                :page="empPage"
                @check="check"
                @dele="dele"
                @get-list="getList"
              />
            </van-tab>
            <!--            <van-tab-->
            <!--              v-if="showTabIndex.indexOf(2) > -1"-->
            <!--              :title="$t('D333','附属人')"-->
            <!--              :name="2"-->
            <!--            >-->
            <!--              <emp-list-->
            <!--                :page="fsrPage"-->
            <!--                :lists="fsrList"-->
            <!--                @get-list="getList"-->
            <!--                @check="check"-->
            <!--                @dele="dele"-->
            <!--                :index="index"-->
            <!--                :checked-list="travelerList"-->
            <!--              />-->
            <!--            </van-tab>-->
          </van-tabs>
        </div>
        <!-- 出差申请单选人 -->
        <emp-list
          v-if="showTab==false"
          :checked-list="travelerList"
          :index="index"
          :lists="empList"
          :page="empPage"
          @check="check"
          @dele="dele"
        />

        <!-- 底部 -->
        <ld-tabbar class="bg-white shadow">
          <van-row
            align="center"
            class="full-width pad-lr-10 text-center"
            justify="space-between"
            type="flex"
          >
            <van-col
              class="font12"
              span="5"
            >
              已添加 <span class="main-color">{{ travelerList.length }}</span>人
            </van-col>
            <van-col span="6">
              <ld-button
                main
                size="md"
                @click="complie"
              >
                {{ $t('B009', '完成') }}
              </ld-button>
            </van-col>
          </van-row>
        </ld-tabbar>

        <!-- 新增 -->
        <van-popup
          v-model="isAddEmp"
          class="full-width full-height"
          close-on-popstate
          position="right"
        >
          <ld-header @click-left="isAddEmp=false" />
          <van-tabs v-model="active">
            <van-tab
              v-if="userInfo.vipCorp.tripType!=2 && empInfo.bookRange!=0"
              name="1"
              title="新增同事"
            >
              <edit-emp
                :simple-header="false"
                class-name="wrapper1"
                @call-back="isAddEmp = false; getResult()"
                :cplx="cplx"
              />
            </van-tab>
            <van-tab
              :title="$t('B033','新增常旅客')"
              name="2"
              v-if="empInfo.bookOutside==1"
            >
              <edit-clk
                :show-header="false"
                class-name="wrapper1"
                @call-back="isAddEmp = false; getResult()"
                :cplx="cplx"
              />
            </van-tab>
          </van-tabs>
        </van-popup>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {Dialog, Overlay, Popup, Search, Tab, Tabs, Tag, Toast} from 'vant'
import EditEmp from 'Views/Home/userCenter/Employee/EditEmp'
import EditClk from 'Views/Home/userCenter/CommonInfo/EditContact'
import {mapGetters,mapState} from 'vuex'
import {getUserInfo} from 'Utils/publicFun'
import ldNavbar from 'Common/ldNavbar'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import ldButton from 'Common/ldButton'
import empList from 'Components/ldEmpList/components/empList.vue'
import { jsGetAgeaccurate,extractBirthdate,typeage } from 'Utils/dateUtil'
import { isGat } from 'Utils/gattools'

export default {
  name: 'LdEmpList',
  components: {
    EditEmp,
    EditClk,
    [Popup.name]: Popup,
    [Search.name]: Search,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Tag.name]: Tag,
    [Overlay.name]: Overlay,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
    ldNavbar,
    ldTabbar,
    ldButton,
    empList,
  },
  props: {
    cplx: {//产品类型
      type: [String, Number],
      default: '',
    },
    personList: {//从外部传入员工列表  例如申请单传入
      type: Array,
      default: function () {
        return []
      }
    },
    hidePerson: {//需要隐藏的出行人列表
      type: Array,
      default: function () {
        return []
      }
    },
    /*
        *挂载节点
        *值为选择器 例如 .tkEdit  #app body
        * 主要解决弹出式头部底部 被当前页面头部底部覆盖的问题
        * 最好挂载到当前页面的根节点上 页面跳转后会相应的移除该控件
        * 没有上面问题 不需传入
        * */
    element: {
      type: String,
      default: ''
    },
    radio: { // 单选
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShow: false,
      showTab: false, // 显示标签为外来人预订 或因私时为true
      showTabIndex: [0, 1, 2],
      showSearch: true,//显示搜索框
      showAddEmp: false,//显示新增员工
      isAddEmp: false,
      fsr: false,//显示附属人
      index: '1', // 0 常旅客 1 同事 2附属人
      value: '', // 搜索关键字
      active: 1,
      empList: [],//员工集合
      empPage: {
        pageNum: 1,
        count: 20,
        total: 0,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了~',
        error: false,
        errorText: '请求失败，点击重新加载'
      },
      clkList: [],//常旅客集合
      clkPage: {
        pageNum: 1,
        count: 20,
        total: 0,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了~',
        error: false,
        errorText: '请求失败，点击重新加载'
      },
      fsrList: [],//附属人集合
      fsrPage: {
        pageNum: 1,
        count: 20,
        total: 0,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了~',
        error: false,
        errorText: '请求失败，点击重新加载'
      },
      cplxObj: { // 根据产品缓存 选中出行人
        '10901': 'tk',
        '10902': 'tkInt',
        '10903': 'ht',
        '10904': 'tr',
        '10913': 'visa',//签证
        '10906': 'car',
        '10914': 'restRoom',//休息室
        '10915': 'fastCheck',//快速安检
        '10916': 'checkIn',//优先值机
        '10917': 'guestPass',//要客通
        '': 'trip'
      },
      allCxrObj: { //根据cplx和页面控制显示所有出行人还是自己
        '10901': 'istrOrtkShowAllcxr',
        '10902': 'istrOrtkShowAllcxr',
        '10904': 'istrOrtkShowAllcxr',
        '10903': 'ishtShowAllcxr',
      },
      empInfo:""
    }
  },
  computed: {
    travelerList() { //获取当前产品已缓存的出行人
      return this.$store.getters[this.cplxObj[this.cplx] + '/travelerList'] || []
    },
    ...mapGetters({
      tripType: 'tripType',
      userInfo: 'userInfo',
      pageCtrl: 'serviceCtrl', //页面控制信息
    }),
    ...mapState({
      carCcsqdNodata: state => state.car.carCcsqdNodata
    })
  },
  created() {
  },
  updated() {
  },
  methods: {
    init() {
      this.fsrPage.pageNum = 1
      this.empPage.pageNum = 1
      this.clkPage.pageNum = 1
      let allCxr = this.pageCtrl[this.allCxrObj[this.cplx]] //根据页面控制信息和产品类型控制是否显示所有出行人
      let userInfo = getUserInfo(this.userInfo, this.cplx)//根据产品 获取权限
      let empInfo = userInfo.empInfo
      this.empInfo=empInfo
      //bookOutside==1 外来人预订权限
      if (empInfo.bookOutside == 1 || this.userInfo.vipCorp.tripType == '2' || empInfo.bookRange!=0 ) {//有外来人预订权限时 可新建员工
        this.showAddEmp = true
      }

      if (this.userInfo.vipCorp.tripType == '2') {
        this.active = 2
        this.index = 0
      }

      if (this.personList.length == 0 || allCxr) {//非外部传入
        this.showTab = true
        //参数判断显示附属人
        this.$api['common/getParListByCodes']({codes: '3002'}).then(res => {
          let cache = res.data || {}
          if (cache.value1 == 1) {
            this.fsr = true
          }
        })
        this.getList()
      } else { //外部传入出行人数据 例如出差申请单时
        this.showTab = false
        this.showSearch = false
        if (this.carCcsqdNodata && this.carCcsqdNodata.tkPsgsdata && this.carCcsqdNodata.tkPsgsdata.length > 0) {//出差申请单我的航班,航班里面的人员信息
          this.carCcsqdNodata.tkPsgsdata.forEach((item, index) => {//适配下单页是不有选中
            let somr = this.travelerList.some((item2) => (item.empId == item2.empId && item.empNo == item.empNo))
            item.checked = somr
          })
          this.$nextTick(() => {
            this.empList = JSON.parse(JSON.stringify(this.carCcsqdNodata.tkPsgsdata))
          })

        } else {//出差申请单里面的人员信息
          this.personList.forEach((item, index) => {//适配下单页是不有选中
            let somr = this.travelerList.some((item2) => (item.empId == item2.empId && item.empNo == item.empNo))
            item.checked = somr
          })
          this.$nextTick(() => {
            this.empList = JSON.parse(JSON.stringify(this.personList)) //深烤备
          })

        }
      }

    },
    dele(info, index) {
      this.travelerList.splice(index, 1)
      if (this.index == 0) {
        this.clkList.forEach(element => {
          if (element.contactsId == info.contactsId) {
            element.checked = false
          }
        })
      } else if (this.index == 1) {
        this.empList.forEach(element => {
          if (element.personId) {
            if (element.personId == info.personId) {
              element.checked = false
            }
          } else if (element.empId == info.empId) {
            element.checked = false
          }
        })
      } else if (this.index == 2) {
        this.fsrList.forEach(element => {
          if (element.empId == info.empId) {
            element.checked = false
          }
        })
      }
    },
    getResult(val) {// 检索
      setTimeout(() => {
        this.getList(val)
      }, 20)
    },
    clear() {//清除检索
      this.value = ''
      if (this.index == 0) {
        this.clkList = []
      } else if (this.index == 1) {
        this.empList = []
      } else {
        this.fsrList = []
      }
      // this.getList()
    },
    complie() {//
      if(isGat()){
        window.history.go(-1)
      }
      if (this.radioStatus() == false) {
        this.travelerList.map((t,index)=>{//在进行选人对类型再进行一遍验证
          if(t.cardType=='NI' && t.born!=''){
            let born=extractBirthdate(t.cardNo)
            t.born=born
            // eslint-disable-next-line indent
					}
          const age = jsGetAgeaccurate(t.born || '') 
          t.psgType=typeage(age)
          // if(age=='NaN'){
          // 	t.psgType = 1// 成人
          // 	return
          // }
          // if (age > 2 && age <= 12) {
          //      t.psgType = 2// 儿童
          //   }
          // if(age < 2){
          //   t.psgType = 3// 婴儿
          //  }
          // if(age > 12){
          //   t.psgType = 1// 成人
          // }
        })
        
        this.$store.commit(this.cplxObj[this.cplx] + '/travelerList', this.travelerList)//传值
        this.$emit('selected', this.travelerList)
        this.toggle()
      }
    },
    addEmp() {//新增员工
      this.isAddEmp = !this.isAddEmp
    },
    changeTab() {
      this.getList()
    },
    getList(queryStr) {
      let obj = {
        '0': {
          url: 'emp/vipEmpContactsPage',
          pageName: 'clkPage',
          dataName: 'clkList',
          params: {// 获取常旅客
            count: 20,
            pageNum: 1,
            cplx: this.cplx,
            queryStr: queryStr,
            tripType: this.tripType
          }
        },
        '1': {
          url: 'emp/empFindList',
          pageName: 'empPage',
          dataName: 'empList',
          params: {// 获取同事
            count: 20,
            pageNum: 1,
            cplx: this.cplx,
            queryStr: queryStr,
            tripType: this.tripType
          }
        },
        '2': {
          url: 'emp/vipEmpContactsPage',
          pageName: 'fsrPage',
          dataName: 'fsrList',
          params: {// 获取附属人
            count: 20,
            pageNum: 1,
            clkFlag: 1,
            cplx: this.cplx,
            queryStr: queryStr,
            tripType: this.tripType
          }
        },
      }

      let cache = obj[this.index]
      let page = this[cache.pageName]
      let self = this
      if (queryStr) {
        cache.params.pageNum = 1
        cache.params.count = 20
        this[cache.pageName].pageNum = 1
      } else {
        cache.params.pageNum = page.pageNum
        cache.params.count = page.count
      }
      this.$api[cache.url](cache.params).then(res => {
        page.loading = false
        let resp = res.data || {}
        let list = resp.list || []
        self[cache.pageName].total = resp.total || 0
        if (list.length > 0) {
          let bool = false
          for (let index = list.length - 1; index >= 0; index--) {
            list[index].checked = false
            if (this.hidePerson.length > 0) {
              this.hidePerson.forEach(el => {
                if (typeof (el.clkFlag) === 'undefined') {
                  if (el.personId === list[index].personId) {
                    resp.list.splice(index, 1)
                    bool = true
                  }
                } else if (el.clkFlag === list[index].clkFlag) {
                  if (el.clkFlag == 0 || el.clkFlag == 1) {
                    if (el.contactsId && (el.contactsId === list[index].contactsId)) {
                      resp.list.splice(index, 1)
                      bool = true
                    }
                  } else if (el.clkFlag == 2) {
                    if (el.psgType == 1 || !el.psgType || el.passengerType == 1 || !el.passengerType) {//干掉儿童
                      if (el.empId && (el.empId === list[index].empId)) {
                        resp.list.splice(index, 1)
                        bool = true
                      }
                    }
                  }
                }
              })
            }
            if (bool) {
              continue
            }
            if (self.travelerList.length > 0) {
              self.travelerList.forEach(el => {
                if (typeof (el.clkFlag) === 'undefined') {
                  if (el.personId === list[index].personId) {
                    //儿童不在员工列表选择中
                    if (el.psgType !== '2' || (el.passengerType && el.passengerType !== 2)) {
                      list[index].checked = true
                    }
                  }
                } else if (el.clkFlag === list[index].clkFlag) {
                  if (el.clkFlag == 0 || el.clkFlag == 1) {
                    if (el.contactsId && (el.contactsId === list[index].contactsId)) {
                      list[index].checked = true
                    }
                  } else if (el.clkFlag == 2) {
                    if (el.psgType == 1 || !el.psgType || el.passengerType == 1 || !el.passengerType) {//干掉儿童
                      if (el.empId && (el.empId === list[index].empId)) {
                        list[index].checked = true
                      }
                    }
                  }
                }
              })
            }
          }

          if (queryStr) {
            self[cache.dataName] = list
          } else {
            if (resp.list.length < page.count) {
              page.finished = true
            }
            if (resp.pageNum > 1 && list.length > 1) {
              this.$nextTick(()=>{
                self[cache.dataName].push(...list)
              })
              // self[cache.dataName].push(...list)
            } else {
              self[cache.dataName] = list
            }
          }
        } else {
          page.finished = true
        }
        if (resp.total == 0) {
          page.finished = true
        }
      }).catch(() => {
        page.error = true
      })
    },
    toggle(obj) {
      this.isShow = !this.isShow
      if (this.isShow) {
        if (obj) { //有值 等于props传值
          Object.assign(this, obj)
        }
        this.init()
      }
    },

    check(info) {// 选中出行人
      let obj = {
        '10901': {maxPerson: 9, tips: '达到单个订单人数上限'},
        '10902': {maxPerson: 9, tips: '达到单个订单人数上限'},
        '10903': {maxPerson: 20, tips: '达到单个订单人数上限'},
        '10904': {maxPerson: 9, tips: '达到单个订单人数上限'},
        '10906': {maxPerson: 30, tips: '达到单个订单人数上限'},
        '10914': {maxPerson: 10, tips: '达到单个订单人数上限'},
        '10915': {maxPerson: 10, tips: '达到单个订单人数上限'},
        '10916': {maxPerson: 10, tips: '达到单个订单人数上限'},
        '10917': {maxPerson: 10, tips: '达到单个订单人数上限'},
        '10913': {maxPerson: 10, tips: '达到单个订单人数上限'},
        '': {maxPerson: 10, tips: '达到人数上限'},//default
      }
      let cache = obj[this.cplx]
      if (cache.maxPerson == this.travelerList.length) {
        if (this.cplx == 10906) {
          '1'
        } else {
          this.$toast(cache.tips)
        }
        this.travelerList.splice(this.travelerList.length - 1, 1)
      } else if (cache.maxPerson < this.travelerList.length) {
        this.$toast(cache.tips)
        this.travelerList.splice(this.travelerList.length - 1, 1)
        return
      }
      const age = jsGetAgeaccurate(info.born || '')
      info.psgType=typeage(age)
      if (info.checked === true) {
        //实时把选中数据缓存
        let bool = this.travelerList.some((item) => {
          if (typeof (info.clkFlag) === 'undefined') {
            if (item.personId) {
              return (item.personId === info.personId)
            }
          } else if (info.clkFlag === item.clkFlag) {
            if (info.clkFlag == 0 || info.clkFlag == 1) {
              return info.contactsId && (info.contactsId === item.contactsId)
            } else if (info.clkFlag == 2) {
              return info.empId && (info.empId === item.empId)
            }
          }
          return false
        })
        if (bool == false) { //这里给push的
          const age = jsGetAgeaccurate(info.born || '')
          info.psgType=typeage(age)
          this.travelerList.push(info)
          this.$forceUpdate()
        }
      } else if (info.checked === false) {
        let indx = -1
        this.travelerList.forEach((item, index) => {
          if (typeof (info.clkFlag) === 'undefined') {
            if (item.personId && item.personId === info.personId) {
              indx = index
            }
          } else if (info.clkFlag === item.clkFlag) {
            if ((info.clkFlag == 0 || info.clkFlag == 1) && info.contactsId && (info.contactsId === item.contactsId)) {
              indx = index
            } else if (info.clkFlag == 2 && info.empId && (info.empId === item.empId)) {
              indx = index
            }
          }
        })
        if (indx > -1) {
          this.travelerList.splice(indx, 1)
        }
      }
      if (info.psgType == 2) {
        var cache_jg = JSON.parse(sessionStorage.getItem('cache'))
        if (!cache_jg) {
          console.log('000')
        } else {
          if (cache_jg.chdFcny == '') {
            info.checked = false
            Dialog.alert({
              title: '温馨提示!',
              message: '该行程不允许预订儿童!',
            }).then(() => {
            })
          }
        }

      }
      this.radioStatus()
    },
    //当前是单选
    radioStatus() {
      if (this.radio) {
        if (this.travelerList.length > 0) {
          this.$emit('radioSelected', this.travelerList[0])
          this.toggle()
        }
        return true
      }
      return false
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      if (this.element) {
        return document.querySelector(this.element)
      }
      return ''
    },
  },
  watch: {
    value(val) {
      //检索
      this.getResult(val)
    }
  }
}
</script>
<style lang="less" scoped>
.emp {
  width: 100%;
  height: 100%;

  .pad-lr-10 {
    padding: 0 10px;
  }
}

/deep/ .van-tabs__content{
  position: relative;
    z-index: 5;
}

</style>
